import { css } from 'styled-jsx/css';

export default css`
  .bar-container {
    position: relative;
  }
  .performance-icon {
    position: absolute;
    top: -5px;
    right: -40px;
  }
  .performance-icon button {
    border: none;
    background: none;
    cursor: pointer;
    margin: 0;
    padding: 0;
  }
  .progress-bar {
    display: flex;
    flex-direction: row;
    height: 8px;
    background: linear-gradient(180deg, #e4e4e4 0%, #949494 100%);
    border-radius: 8px;
    position: relative;
  }
  .progress-bar-width {
    width: 90%;
  }
  .thick-bar {
    height: 16px;
  }

  .progress {
    height: 100%;
    background: #3f4602;
    background: linear-gradient(270deg, #7ed321 0%, #509508 100%);
    display: flex;
    border-radius: 8px;
  }

  .progress.under {
    background: #f76c1c;
    background: linear-gradient(270deg, #f76b1c 0%, #c44700 100%);
  }

  .progress.over {
    background: #9014fe;
    background: linear-gradient(270deg, #9013fe 0%, #510895 100%);
  }

  .progress-bar-over .progress {
    border-radius: 8px 0 0 8px;
  }

  .progress-bar-over .progress.over {
    border-radius: 0 8px 8px 0;
  }

  .survey-progress-bar {
    display: flex;
    flex-direction: row;
    height: 4px;
    background: linear-gradient(180deg, #e4e4e4 0%, #949494 100%);
    border-radius: 8px;
    position: relative;
  }

  .survey-progress {
    background: linear-gradient(90deg, #950810 0%, #fd0300 100%);
    display: flex;
    border-radius: 8px;
  }

  .target {
    width: 4px;
    height: 16px;
    margin-top: -4px;
    margin-left: -2px;
    background: #7ed321;
    position: absolute;
  }
  .thick-target {
    height: 24px;
  }

  @media (max-width: 1024px) {
    .progress-bar-width {
      width: 95%;
    }
  }
`;
